// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.icon-status[data-v-b24c7ed8] {\n  padding: 9px 20px;\n  height: 30px;\n  font-size: 12px;\n  border-radius: 15px;\n  line-height: 12px;\n  min-width: 70px;\n  color: white;\n}\n.icon-status--navy[data-v-b24c7ed8] {\n  background-color: #012755;\n}\n.icon-status--gray[data-v-b24c7ed8] {\n  background-color: #CBCBCB;\n}\n", ""]);
// Exports
module.exports = exports;
